import { render } from "./FarmerRewardDisplay2.vue?vue&type=template&id=b1de029e&ts=true"
import script from "./FarmerRewardDisplay2.vue?vue&type=script&lang=ts"
export * from "./FarmerRewardDisplay2.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Workspace\\weedheads\\10-gemfarm\\custom-ui\\gem-farm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__